import { render } from "./Rating.vue?vue&type=template&id=3a7dda35"
import script from "./Rating.vue?vue&type=script&setup=true&lang=js"
export * from "./Rating.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Bread/Resources/ui/Components/Table/Fields/Rating.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a7dda35"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a7dda35', __exports__)) {
    api.reload('3a7dda35', __exports__)
  }
  
  module.hot.accept("./Rating.vue?vue&type=template&id=3a7dda35", () => {
    api.rerender('3a7dda35', render)
  })

}


export default __exports__